import {MaterialSymbol, MaterialSymbolProps} from './MaterialSymbol';

export const LeftPanelCloseIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>left_panel_close</MaterialSymbol>
);

export const RightPanelCloseIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>right_panel_close</MaterialSymbol>
);

export const LeftPanelOpenIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>left_panel_open</MaterialSymbol>
);

export const RightPanelOpenIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>right_panel_open</MaterialSymbol>
);

export const GroupsIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>groups</MaterialSymbol>
);

export const FramePersonIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>frame_person</MaterialSymbol>
);

export const RoomServiceIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>room_service</MaterialSymbol>
);

export const BoltIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>bolt</MaterialSymbol>
);

export const HomeIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>home</MaterialSymbol>
);

export const InboxIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>inbox</MaterialSymbol>
);

export const MailIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>mail</MaterialSymbol>
);

export const MobileChatIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>mobile_chat</MaterialSymbol>
);

export const PersonIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>person</MaterialSymbol>
);

export const PersonOffIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>person_off</MaterialSymbol>
);

export const ReplyIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>reply</MaterialSymbol>
);

export const SignalCellularAlt1BarIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>signal_cellular_alt_1_bar</MaterialSymbol>
);

export const SignalCellularAlt2BarIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>signal_cellular_alt_2_bar</MaterialSymbol>
);

export const SignalCellularAltIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>signal_cellular_alt</MaterialSymbol>
);

export const SnoozeIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>snooze</MaterialSymbol>
);

export const CheckCircleIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>check_circle</MaterialSymbol>
);

export const EmergencyHomeIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>emergency_home</MaterialSymbol>
);

export const EventIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>event</MaterialSymbol>
);

export const VillaIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>villa</MaterialSymbol>
);

export const RuleSettingsIcon = (props: MaterialSymbolProps) => (
  <MaterialSymbol {...props}>rule_settings</MaterialSymbol>
);
